import { ProgressCircle } from './ProgressCircle'
import { ArrowIcon } from './ArrowIcon'
import { SliderItemProps } from '~/components/ContentfulEntries/DescriptiveSlider/types'

export const SliderItem = ({ item, activeItem, isActive, onClick }: SliderItemProps) => (
  <>
    <div
      className={`flex py-3 px-4 items-start gap-2 self-stretch rounded-2xl ${
        isActive ? 'bg-neutral-10' : 'bg-white'
      } hover:cursor-pointer hover:bg-neutral-10 transition-all duration-150`}
      onClick={onClick}
    >
      <span className="flex-1 text-xs text-neutral-60">{item.title || ''}</span>
      <div className="size-4.5 aspect-square">{isActive ? <ProgressCircle /> : <ArrowIcon />}</div>
    </div>
    {/* Slider content for mobile only */}
    {activeItem.title && item.title && activeItem.title === item.title && (
      <div className="flex md:hidden flex-col flex-1 items-start gap-2 p-6 self-stretch rounded-2xl bg-white animate-fade-in">
        <span className="text-s text-neutral-100 self-stretch">{activeItem.title}</span>
        <span className="text-xs text-neutral-60 self-stretch">{activeItem.description || ''}</span>
      </div>
    )}
  </>
)
